import { rtkQuerieSetup } from '../services/rtkQuerieSetup';


export const clientSidePostApis = rtkQuerieSetup.injectEndpoints({
    endpoints: (builder) => ({
        addToCart: builder.mutation({
            query: (body) => ({
                url: `/user/add-cart`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Cart'],
        }),
        removeCartItem: builder.mutation({
            query: (cartItemId) => ({
                url: `/user/cart/${cartItemId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Cart'],
        }),
        updateCartItemQuantity: builder.mutation({
            query: ({ cartItemId, quantity }) => ({
                url: `/user/cart/${cartItemId}`,
                method: 'PUT',
                body: { quantity },
            }),
            invalidatesTags: ['Cart'],
        }),
        applyCoupon: builder.mutation({
            query: (body) => ({
                url: `/user/cart/coupon`,
                method: 'POST',
                body,
            }),
        }),
        removeCoupon: builder.mutation({
            query: () => ({
                url: `/user/coupon-remove`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Cart'],
        }),
        addToWishlist: builder.mutation({
            query: (body) => ({
                url: `/user/wishlist`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Wishlist'],
        }),
        removeFromWishlist: builder.mutation({
            query: (body) => ({
                url: `/user/wishlist`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['Wishlist'],
        }),
        postContactUs: builder.mutation({
            query: (body) => ({
                url: `/user/post-contact-us`,
                method: 'POST',
                body,
            }),
        }),
        subscribeToNewsletter: builder.mutation({
            query: (body) => ({
                url: `/user/post-subscribers`,
                method: 'POST',
                body,
            }),
        }),
        addUserAddress: builder.mutation({
            query: (body) => ({
                url: `/user/add-address`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Addresses', 'GlobalData', 'Cart'],
        }),
        updateUserAddress: builder.mutation({
            query: ({ body, addressId }) => ({
                url: `/user/update-address/${addressId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Addresses', 'GlobalData', 'Cart'],
        }),
        deleteUserAddress: builder.mutation({
            query: (addressId) => ({
                url: `/user/delete-address/${addressId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Addresses', 'GlobalData', 'Cart'],
        }),
        placeOrder: builder.mutation({
            query: (body) => ({
                url: `/user/place-order`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Cart', 'MyOrders'],
        }),
        orderConfirmed: builder.mutation({
            query: (body: { checkout_session_id: string; order_id: string }) => ({
                url: `/user/stripe/confirm`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Cart', 'MyOrders'],
        }),
        updateUserProfile: builder.mutation({
            query: (body) => ({
                url: `/user/update-profile`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['UserProfile'],
        }),
        updateUserNotification: builder.mutation({
            query: (body) => ({
                url: `/user/notification-preferences`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['UserProfile'],
        }),
        changeUserPassword: builder.mutation({
            query: (body) => ({
                url: `/user/change-password`,
                method: 'POST',
                body,
            }),
        }),
        deleteUserAccount: builder.mutation({
            query: () => ({
                url: `/user/delete-account`,
                method: 'DELETE',
            }),
        }),
        submitReturnReplacement: builder.mutation<void, FormData>({
            query: (body) => ({
                url: `/user/return-replacement`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, body) => {
                const orderId = body.get('order_id') as string | null;
                return orderId
                    ? ['MyOrders', { type: 'MyOrders', id: orderId }]
                    : ['MyOrders'];
            },
        }),
        buyMembership: builder.mutation({
            query: (body) => ({
                url: `/user/buy-membership`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['UserProfile', 'Cart'],
        }),
        cancelOrder: builder.mutation({
            query: ({ orderId, body }) => ({
                url: `/user/orders/${orderId}/cancel`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { orderId }) => [
                'MyOrders',
                { type: 'MyOrders', id: orderId },
            ],
        }),
        reOrderItems: builder.mutation({
            query: (orderId: string) => ({
                url: `/user/orders/${orderId}/reorder`,
                method: 'POST',
            }),
            invalidatesTags: ['Cart', 'MyOrders'],
        }),
    }),
});

export const {
    useAddToCartMutation,
    useRemoveCartItemMutation,
    useUpdateCartItemQuantityMutation,
    usePostContactUsMutation,
    useSubscribeToNewsletterMutation,
    useAddUserAddressMutation,
    useUpdateUserAddressMutation,
    useDeleteUserAddressMutation,
    usePlaceOrderMutation,
    useOrderConfirmedMutation,
    useApplyCouponMutation,
    useRemoveCouponMutation,
    useAddToWishlistMutation,
    useRemoveFromWishlistMutation,
    useUpdateUserProfileMutation,
    useUpdateUserNotificationMutation,
    useChangeUserPasswordMutation,
    useDeleteUserAccountMutation,
    useSubmitReturnReplacementMutation,
    useBuyMembershipMutation,
    useCancelOrderMutation,
    useReOrderItemsMutation,
} = clientSidePostApis;
